import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { UnsavedChangesProvider } from './UnsavedChanges';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ErrorBoundary, ToastProvider } from '@yingbaba/ui';
import { configure } from '@yingbaba/api';
import '@yingbaba/tokens/style.css';
import { App } from './App';
configure();
const query = new QueryClient({ defaultOptions: { queries: { staleTime: 15_000, retry: 1 } } });
const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <ErrorBoundary>
        <UnsavedChangesProvider>
          <App />
        </UnsavedChangesProvider>
      </ErrorBoundary>
    ),
  },
]);
createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={query}>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
